/**
 * JS pro Lazy loading iframu s videem.
 * počítá s jedním videem na stránce s id="video-player"
 */


export default function () {
	document.addEventListener("DOMContentLoaded", function() {
		// Internet Explorer nepodporuje IntersectionObserver ve starších verzích 11 a starší
		let isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

		let iframes = document.querySelectorAll(".ll-iframe");

		if (iframes.length === 0) {
			return false;
		}

		if (!isIE) {
			iframes.forEach(function (iframe) {
				let observer = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							// Extrahujeme URL z data-src a nastavíme src
							let dataSrc = iframe.getAttribute("data-src");
							if (dataSrc) {
								iframe.setAttribute("src", dataSrc);
								observer.disconnect();
							}
						}
					});
				}, {threshold: 0.5});
				observer.observe(iframe);
			});
		} else {
			// Internet Explorer, načteme src z data-src ihned pro každý iframe
			iframes.forEach(function (iframe) {
				let dataSrcIE = iframe.getAttribute("data-src");
				if (dataSrcIE) {
					iframe.setAttribute("src", dataSrcIE);
				}
			});
		}
	});
}
